import { Injectable, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

import { JwtHelper } from 'angular2-jwt';
import { UserLoginService, 
         CognitoUtil,
         Callback } from "./cognito.service";

@Injectable()
export class CognitoTokensService {
    constructor(private router: Router,
                private jwtHelper : JwtHelper,              
                private userLoginService: UserLoginService,
                private cognitoUtil: CognitoUtil,
               ) {
    }

    checkTokenExpiry() {  
        //console.log('old id token : '+ localStorage.getItem("idToken"), ' old access token : ' + localStorage.getItem("accessToken"));
        if(localStorage.getItem("idToken")) {
            if(this.jwtHelper.decodeToken(localStorage.getItem("idToken")).exp - (Math.floor(new Date().getTime()/1000)) <=  600) {    
                return this.updateTokens();   
            } else {
                return true;
            }
        } else {
            return false;
        }
        
        // if(localStorage.getItem("idToken") && localStorage.getItem("idToken") != null
        // && localStorage.getItem("idToken") != 'null' && localStorage.getItem("idToken") != undefined) {    
        //     let isExpired = this.jwtHelper.isTokenExpired(localStorage.getItem("idToken"));           
        //     if(isExpired) {
        //         console.log("inside");
        //         return this.updateTokens();
        //         //return true;
        //     } else {
        //         return true;
        //     }	

        // } else {
        //     return false;
        // }
    }

    updateTokens() {   
        // console.log("Old token"+localStorage.getItem("idToken"));  
        if(localStorage.getItem("refreshToken")) {
            this.cognitoUtil.getRefreshSession(new SessionCallback(this));
            return true;
        } else {
            return false;
        } 
        // this.cognitoUtil.getAccessToken(new AccessTokenCallback(this));
        // this.cognitoUtil.getIdToken(new IdTokenCallback(this));        
        
    }
}

// export class AccessTokenCallback implements Callback {
//     constructor(public ctService: CognitoTokensService) { }

//     callback() { }

//     callbackWithParam(result) {
//         if(result != null) {
//             localStorage.setItem("accessToken", result);
//             // console.log("New Token"+localStorage.getItem("idToken"));
//         } else {

//         }
      
//     }
// }

// export class IdTokenCallback implements Callback {
//     constructor(public ctService: CognitoTokensService) { }

//     callback() { }

//     callbackWithParam(result) {
//         if(result != null) {
//             localStorage.setItem("idToken", result);
//         } else {
            
//         }      
//     }
// }

export class SessionCallback implements Callback {
    constructor(public ctService: CognitoTokensService) { }

    callback() { }

    callbackWithParam(result) {
        if(result != null) {
            localStorage.setItem("accessToken", result.getAccessToken().getJwtToken());
            localStorage.setItem("idToken", result.getIdToken().getJwtToken());
            //console.log('new id token : '+ localStorage.getItem("idToken"), ' new access token : ' + localStorage.getItem("accessToken"))
        } else {
            
        }      
    }
}


// WEBPACK FOOTER //
// ./src/app/services/cognito/cognito-tokens.service.ts